interface IValues {
	isModalOpen: boolean;
	phoneNumber: string;
	password: string;
	isView: boolean;
}

interface IGoldValues {
	goldRateUpdate: number;
	goldPrice24k: string;
	goldPrice22k: string;
	goldPrice20k: string;
	goldPrice18k: string;
	goldPrice16k: string;
}

interface IModalValues {
	isModalOpen: boolean;
	staticArrTitle: string;
	currentPassword: string;
	newPassword: string;
	confirmPassword: string;
	phoneNumber: string;
}

export const validateLogin = (values: IValues) => {
	const errors: Partial<IValues> = {};
	if (!values.phoneNumber) {
		errors.phoneNumber = 'Required';
	}
	if (!values.password) {
		errors.password = 'Required';
	}
	return errors;
};
export const validateGoldPriceUpdate = (values: IGoldValues) => {
	const errors: Partial<IGoldValues> = {};
	if (!values.goldPrice24k) {
		errors.goldPrice24k = 'Required';
	}
	if (!values.goldPrice22k) {
		errors.goldPrice22k = 'Required';
	}
	if (!values.goldPrice20k) {
		errors.goldPrice20k = 'Required';
	}
	if (!values.goldPrice18k) {
		errors.goldPrice18k = 'Required';
	}
	if (!values.goldPrice16k) {
		errors.goldPrice16k = 'Required';
	}
	return errors;
};

export const validateModal = (values: IModalValues) => {
	const errors: Partial<IModalValues> = {};
	if (!values.currentPassword) {
		errors.currentPassword = 'Required';
	}
	if (!values.newPassword) {
		errors.newPassword = 'Required';
	} else if (values.newPassword.length < 8) {
		errors.newPassword = 'Minimum 8 character length';
	} else if (
		values.newPassword.length >= 8 &&
		(!/[A-Z]/.test(values.newPassword) ||
			!/\d/.test(values.newPassword) ||
			!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(values.newPassword))
	) {
		errors.newPassword =
			'Atleast 1 letter should be Uppercase and 1 number and 1 special Characters';
	} else if (values.newPassword === values.currentPassword) {
		errors.newPassword = 'New Password should be not equal to Current Password';
	}
	if (!values.confirmPassword) {
		errors.confirmPassword = 'Required';
	} else if (values.confirmPassword.length < 8) {
		errors.confirmPassword = 'Minimum 8 character length';
	} else if (
		values.confirmPassword.length >= 8 &&
		(!/[A-Z]/.test(values.confirmPassword) ||
			!/\d/.test(values.confirmPassword) ||
			!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(values.confirmPassword))
	) {
		errors.confirmPassword =
			'Atleast 1 letter should be Uppercase and 1 number and 1 special Characters';
	} else if (values.confirmPassword !== values.newPassword) {
		errors.confirmPassword = 'New Password and Confirm must be equal';
	}
	return errors;
};
